import React, { useEffect, useState } from "react";
import Footer from "../../../CoreComponents/Footer";
import Header from "../../../CoreComponents/Header";
import MainHeader from "../../../CoreComponents/MainHeader";
import NavBar from "../../../CoreComponents/NavBar";
// import { MyVerticallyCenteredModal } from "../../../CoreComponents/VerticallyCenteredModal";
import {
  ManageVariants,
  showMessage,
  getToken,
} from "../../../Functionalities/Functions";
import axios from "axios";
import { protocol } from "../../../Functionalities/Config";
import FilterComponent from "../../../CoreComponents/FilterComponent";
function Body(props) {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [edit, setEdit] = useState(false);
  const [modal, setModal] = useState(false);

  const clearHandler = () => {
    setData({
      ...data,
      id: "",
      name: "",
    });
  };

  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    showMessage("Loading variants", "info", "Loading", "bottom", "bottom-left", 0);
    let result = ManageVariants("", "get", "", "");
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results,
        });
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const editFunction = (e, varient) => {
    setEdit(true);
    setData({
      ...data,
      name: varient.name,
      id: varient.id,
    });
  };

  return (
    <div class="content-body">
      <div class="container-fluid">
        <div className="row">
          <div className="col-xl-12 ">
            <div className="card">
              <div className="card-header border-0 pb-0 d-sm-flex d-block"></div>

              <FilterComponent
                handleNext={handleNext}
                handlePrev={handlePrev}
                next={next}
                prev={prev}
                addItemName={"Add Varient"}
                modalButton={true}
              />
              <div className="card-body ">
                <table className="table table-responsive-md">
                  <thead>
                    <tr>
                      <th>Varient Id</th>
                      <th>Varient Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    <div
                      className="modal fade"
                      id="sendMessageModal"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="card-header">
                            <h4 className="card-title">
                              <>Edit Varient</>
                            </h4>
                          </div>

                          <div className="modal-body">
                            <form className="comment-form">
                              <div className="row">
                                <form>
                                  <div className="form-group row align-items-center">
                                    <div className="col-sm-6">
                                      <label>Name</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={data.name}
                                        onChange={(e) =>
                                          setData({
                                            ...data,
                                            name:
                                              e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="form-group row">
                                    <div className="col-sm-12 text-center">
                                      <button // className="close"
                                        data-dismiss="modal"
                                        className="btn btn-primary mr-1"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          clearHandler();
                                        }}
                                      >
                                        close
                                                      </button>
                                      {edit ? (
                                        <button // className="close"
                                          data-dismiss={
                                            modal && `modal`
                                          }
                                          className="btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            // clickFunction()
                                            let res = ManageVariants(
                                              e,
                                              "update",
                                              data
                                            );
                                            setModal(false);
                                            res.then();
                                            res.then((res) => {
                                              if (res.data.Status === true) {
                                                // alert(
                                                //   "Success"
                                                // );
                                                showMessage("Variant updated", "success", "Success!", "top", "top-right", 0)
                                                window.location.reload();
                                              } else {
                                                showMessage("Variant update error", "danger", "Error!", "top", "top-right", 0)
                                              }
                                            }).catch(err => {
                                              showMessage("Error", "danger", "Error!", "top", "top-right", 0)
                                            })
                                          }}
                                        >
                                          Save
                                        </button>
                                      ) : (
                                        <button
                                          className="close"
                                          data-dismiss="modal"
                                          className="btn btn-primary"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            // clickFunction()
                                            let res = ManageVariants(
                                              e,
                                              "add",
                                              data
                                            );
                                            setModal(false);
                                            res.then();
                                            res.then((res) => {
                                              if (res.data.Status === true) {
                                                showMessage("New vriant added", "success", "Success", "top", "top-right", 0)
                                                window.location.reload();
                                              } else {
                                                showMessage(res.data.Error, "danger", "Error!", "top", "top-right", 0)

                                              }
                                            }).catch(err => {
                                              showMessage("Error", "danger", "Error!", "top", "top-right", 0)
                                            })
                                          }}
                                        >
                                          Add
                                        </button>
                                      )}{" "}
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    {data.data.length > 0 &&
                      data.data.map((varient, index) => {
                        return (
                          <tr>
                            <td>
                              <h5 className="mb-0 fs--1"> FDRVRT{index + 1}</h5>
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <span className="w-space-no">
                                  {varient.name}
                                </span>
                              </div>
                            </td>
                            <td>
                              <div className="d-flex">
                                <div className="form-group row">
                                  <div className="col-sm-9">
                                    <p>
                                      <a
                                        href=""
                                        data-toggle="modal"
                                        data-target="#sendMessageModal"
                                        onClick={(e) =>
                                          editFunction(e, varient)
                                        }
                                      >
                                        <span
                                          className="item"
                                          className="btn btn-primary shadow btn-xs sharp mr-1"
                                        >
                                          <i className="fa fa-pencil"></i>
                                        </span>
                                      </a>
                                    </p>


                                  </div>
                                </div>

                                <div
                                  href=""
                                  onClick={(e) => {
                                    e.preventDefault();
                                    // clickFunction()
                                    let res = ManageVariants(
                                      e,
                                      "delete",
                                      "",
                                      `id=${varient.id}`
                                    );
                                    setModal(false);
                                    res.then();
                                    res.then((res) => {
                                      if (res.data.Status === true) {
                                        // alert("Success");
                                        showMessage("Variant deleted", "success", "Success!", "top", "top-right", 0)
                                        window.location.reload();
                                      } else {
                                        showMessage(res.data.Error, "danger", "Error!", "top", "top-right", 0)
                                      }
                                    }).catch(err => {
                                      showMessage("Error", "danger", "Error!", "top", "top-right", 0)
                                    })
                                  }}
                                >
                                  <span className="btn btn-danger shadow btn-xs sharp">
                                    <i className="fa fa-trash" />
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}{" "}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Variant() {
  const headers = "";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Variants"}
          subHeading={"  Variants are used to measure quantity uniquely"}
        />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Variant;
